import { StandardEvents } from '@shopify/events';

function updateCount(count) {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-ts-cart-count]').forEach(node => {
    node.textContent = '(' + count + ')';
  });
}

function dismiss() {
  const panel = document.querySelector('[data-ts-cart-confirmation]');
  if (panel) panel.hidden = true;
}

document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
  try {
    const result = await event.promise;
    if (!result) return;
    updateCount(result.cart?.totalQuantity);
    if (event.action !== 'add' || result.detail?.didError) return;
    const panel = document.querySelector('[data-ts-cart-confirmation]');
    const message = panel?.querySelector('[data-ts-cart-message]');
    const text = document.querySelector('[data-ts-cart-feedback-text]');
    if (!panel || !message || !text) return;
    panel.hidden = false;
    message.textContent = '';
    requestAnimationFrame(() => {
      message.textContent = JSON.parse(text.textContent);
    });
  } catch {
    dismiss();
  }
});

document.addEventListener('click', event => {
  if (event.target instanceof Element && event.target.closest('[data-ts-cart-dismiss]')) dismiss();
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') dismiss();
});
window.addEventListener('pageshow', async event => {
  if (!event.persisted) return;
  dismiss();
  try {
    const link = document.querySelector('.ts-cart');
    if (!link) return;
    const response = await fetch(link.pathname + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (response.ok) updateCount((await response.json()).item_count);
  } catch {}
});
